function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferDeadlineEducationModalImage = function SvgTransferDeadlineEducationModalImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 475.01 199.89"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__a",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 157a1 1 0 0 1 0-2h112.36a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__b",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-474-113H966v781H-474z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__c",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 94a1 1 0 0 1 0-2h112.36a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__d",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 106a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__e",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 170a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__f",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304 157a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__g",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228 112a1 1 0 0 1 0-2h112.36a1 1 0 0 1 0 2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__h",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308 140.74V123.9a4.18 4.18 0 0 1 4.21-4.21h35.09v-18.25a4.21 4.21 0 0 1 7.19-3l30.87 30.88a4.22 4.22 0 0 1 0 6l-30.87 30.88a4.21 4.21 0 0 1-7.19-3V145h-35.09a4.2 4.2 0 0 1-4.21-4.21Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__i",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 25,
    x: 91,
    y: 120,
    rx: 6,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__j",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.16 35.57h139.53v174.32H154.16z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__k",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.3 35.57h139.42v159.15H168.3z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__l",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.3 35.57v158.77h100.72l38.69-37.81V35.57z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__m",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.89 20h140.06v49.48H167.89z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__n",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.89 20-13.73 15.57-.16 49.89 13.89-15.98z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__o",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.89 194.32-13.73 15.57h139.52l13.74-15.57z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__p",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.55 43h-69.94a4.77 4.77 0 1 1 0-9.53h69.94a4.77 4.77 0 0 1 0 9.53",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__q",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.57 43h-13.52a4.77 4.77 0 1 1 0-9.53h13.52a4.77 4.77 0 0 1 0 9.53",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__r",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 20h153.96v189.89H154z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__s",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179 78h129v117H179z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__t",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 20h154v190H154z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__u",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.16 194.54v-38.1h38.76z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__v",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 130.88a.24.24 0 0 1 .19-.07.35.35 0 0 1 .21.07l.65.68a.2.2 0 0 1 .1.18.3.3 0 0 1-.1.22l-7 7a.27.27 0 0 1-.18.07.4.4 0 0 1-.21-.07l-3.13-3.15a.23.23 0 0 1-.09-.19.3.3 0 0 1 .09-.21l.66-.65a.26.26 0 0 1 .21-.1.22.22 0 0 1 .19.1l2.28 2.27Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__w",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.64 108.36v-5.45a1.64 1.64 0 0 0-1.64-1.64h-5.45a1.64 1.64 0 0 0-1.64 1.64v5.45a1.64 1.64 0 0 0 1.64 1.64H54a1.64 1.64 0 0 0 1.64-1.64m0 13.09V116a1.64 1.64 0 0 0-1.64-1.64h-5.45a1.64 1.64 0 0 0-1.64 1.64v5.45a1.64 1.64 0 0 0 1.64 1.64H54a1.64 1.64 0 0 0 1.64-1.64m0 13.09v-5.45a1.6 1.6 0 0 0-.48-1.16 1.57 1.57 0 0 0-1.16-.48h-5.45a1.57 1.57 0 0 0-1.16.48 1.6 1.6 0 0 0-.48 1.16v5.45a1.55 1.55 0 0 0 .48 1.16 1.57 1.57 0 0 0 1.16.48H54a1.57 1.57 0 0 0 1.16-.48 1.55 1.55 0 0 0 .48-1.16M46.91 158v-11.45a1.55 1.55 0 0 0-.48-1.16 1.57 1.57 0 0 0-1.16-.48h-5.45a1.57 1.57 0 0 0-1.16.48 1.55 1.55 0 0 0-.48 1.16V158Zm-10.36-21.82a1.62 1.62 0 0 0 1.63-1.64v-5.45a1.62 1.62 0 0 0-.47-1.16 1.6 1.6 0 0 0-1.16-.48h-5.46a1.64 1.64 0 0 0-1.64 1.64v5.45a1.55 1.55 0 0 0 .48 1.16 1.6 1.6 0 0 0 1.16.48ZM29.45 116v5.45a1.57 1.57 0 0 0 .48 1.16 1.6 1.6 0 0 0 1.16.48h5.46a1.62 1.62 0 0 0 1.63-1.64V116a1.62 1.62 0 0 0-1.63-1.64h-5.46a1.6 1.6 0 0 0-1.16.48 1.57 1.57 0 0 0-.48 1.16m0-13.09v5.45a1.57 1.57 0 0 0 .48 1.16 1.6 1.6 0 0 0 1.16.48h5.46a1.62 1.62 0 0 0 1.63-1.64v-5.45a1.62 1.62 0 0 0-1.63-1.64h-5.46a1.6 1.6 0 0 0-1.16.48 1.57 1.57 0 0 0-.48 1.16m42 55.09a1.62 1.62 0 0 1 1.63 1.64v2.72H12v-2.72a1.64 1.64 0 0 1 1.64-1.64h2.72V95.82a3.28 3.28 0 0 1 3.28-3.28h45.82a3.28 3.28 0 0 1 3.27 3.28V158Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-deadline-education-modal-image_svg__x",
    transform: "translate(-7 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.84 115.48h11.23v33.68h11.23v-33.68h11.22v33.68h11.23v-33.68H463v33.68h6.31a2 2 0 0 1 1.5.61 2.07 2.07 0 0 1 .61 1.49v3.51h-73v-3.51a2.07 2.07 0 0 1 .61-1.49 2 2 0 0 1 1.5-.61h6.31Zm66 42.1a4.18 4.18 0 0 1 4.21 4.21v2.81a1.4 1.4 0 0 1-.39 1 1.37 1.37 0 0 1-1 .39h-81.4a1.37 1.37 0 0 1-1-.39 1.4 1.4 0 0 1-.39-1v-2.81a4.18 4.18 0 0 1 4.21-4.21Zm4.16-53.33v2.81a1.36 1.36 0 0 1-.39 1 1.34 1.34 0 0 1-1 .4h-4.21v2.1a2.08 2.08 0 0 1-2.11 2.11h-68.76a2.08 2.08 0 0 1-2.11-2.11v-2.1h-4.21a1.34 1.34 0 0 1-1-.4 1.36 1.36 0 0 1-.39-1v-2.81a1.43 1.43 0 0 1 .22-.79 1.33 1.33 0 0 1 .65-.53l40.7-15.43a.7.7 0 0 0 .22 0 1.2 1.2 0 0 1 .62 0 .7.7 0 0 0 .22 0l40.7 15.43a1.33 1.33 0 0 1 .65.53 1.43 1.43 0 0 1 .2.79",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 135h124.36v12H92z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 72h124.36v12H102z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__d)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 84h23v12h-23z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__e)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 148h34v12h-34z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__f)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291 135h34v12h-34z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__g)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215 90h124.36v12H215z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__h)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 77.23h88.59v80.17H296z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__i)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 100h240v35H79z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__j)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.16 15.57h149.53v184.32H142.16z",
    style: {
      fill: "#fff9e5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__k)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.3 15.57h149.42v169.15H156.3z",
    style: {
      fill: "#fff9e5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__l)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.3 15.57h149.42v168.77H156.3z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__m)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.89 0h150.06v59.48H155.89z",
    style: {
      fill: "#d83a3a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__n)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142 0h23.89v75.46H142z",
    style: {
      fill: "#bf2525"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__o)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.16 174.32h163.26v25.57H142.16z",
    style: {
      fill: "#ffefbb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__p)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.84 13.47h89.47V33h-89.47z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__q)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.28 13.47h33.05V33h-33.05z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__r)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__s)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__t)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.44 104.15h-22.08V82.07h22.08Zm-21.19-.89h20.3V83h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63 104.15h-22.08V82.07h22.08Zm-21.19-.89h20.3V83h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82 104.15h-22.08V82.07h22.08Zm-21.19-.89h20.3V83h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 104.15h-22.07V82.07H269Zm-21.18-.89h20.29V83h-20.29Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.19 104.15h-22.08V82.07h22.08Zm-21.19-.89h20.3V83H269ZM205.44 125.34h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63 125.34h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82 125.34h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 125.34h-22.07v-22.08H269Zm-21.18-.89h20.29v-20.3h-20.29Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.19 125.34h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3H269ZM205.44 146.53h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63 146.53h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82 146.53h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 146.53h-22.07v-22.08H269Zm-21.18-.89h20.29v-20.3h-20.29Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.19 146.53h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3H269ZM205.44 167.72h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63 167.72h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82 167.72h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3h-20.3Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 167.72h-22.07v-22.08H269Zm-21.18-.89h20.29v-20.3h-20.29Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.19 167.72h-22.08v-22.08h22.08Zm-21.19-.89h20.3v-20.3H269Z",
    style: {
      fill: "#d1d1d1"
    },
    transform: "translate(-7 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__u)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__t)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.16 136.44h48.76v48.11h-48.76z",
    style: {
      fill: "#f1f2f3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__t)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.55 147.71a12.56 12.56 0 1 1 12.56-12.56 12.57 12.57 0 0 1-12.56 12.56m0-21.2a8.64 8.64 0 1 0 8.64 8.64 8.66 8.66 0 0 0-8.64-8.64",
    style: {
      fill: "#bf2525"
    },
    transform: "translate(-7 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__v)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__t)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.38 110.81h20.75v18.26h-20.75z",
    style: {
      fill: "#bf2525"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__w)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 72.54h71.09v79.82H0z",
    style: {
      fill: "#fff9e5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__x)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#transfer-deadline-education-modal-image_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.81 67.41h94.21V156h-94.21z",
    style: {
      fill: "#fff9e5"
    }
  }))));
};
export default SvgTransferDeadlineEducationModalImage;